import {ISOString} from '@/types';

export abstract class CacheStorageAbstract {
  abstract getCacheByKey<T>(key: string): CacheData<T> | null;
  abstract setCacheByKey<T>(key: string, data: CacheData<T>): void;
  abstract clearCacheByKey(key: string): void;
}

export type CacheData<T> = {
  data: T;
  cacheCreatedAt: ISOString;
};
